import React, { useEffect } from "react";
import CaseStudyTemplatePage from "components/CaseStudyTemplate/CaseStudyTemplate";

import { useTranslation } from "react-i18next";

import imgBanner from "assets/images/pages/bi-banner.jpg";
import imgIdeas2 from "assets/images/pages/bi-healthcare-solution/bi_ideas2.jpg";
import imgIdeas1 from "assets/images/pages/bi-healthcare-solution/bi-ideas1.jpg";
import imgResult1 from "assets/images/pages/bi-healthcare-solution/bi-result1.jpg";
import imgResult2 from "assets/images/pages/bi-healthcare-solution/bi-result2.jpg";
import imgResult3 from "assets/images/pages/bi-healthcare-solution/bi-result3.jpg";
import imgResult4 from "assets/images/pages/bi-healthcare-solution/bi-result4.jpg";
import { PAGES } from "constants/pages";

const CaseStudyBIHealthcareSolutionPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = PAGES.CASE_STUDY_BI_HEALTHCARE_SOLUTION.title;
  }, []);
  const data = {
    banner: {
      header: "caseStudies.biHealthcareSolution.banner.header",
      text: "caseStudies.biHealthcareSolution.banner.text",
      badges: t("caseStudies.biHealthcareSolution.banner.badges", {
        returnObjects: true,
      }),
      image: imgBanner,
      imageHeight: 618,
    },
    stats: t("caseStudies.biHealthcareSolution.stats", { returnObjects: true }),
    description: {
      header: "caseStudies.biHealthcareSolution.description.header",
      pargarafs: [
        {
          image: imgIdeas1,
          text: "caseStudies.biHealthcareSolution.description.paragrafs.paragraf1",
        },
        {
          image: imgIdeas2,
          text: "caseStudies.biHealthcareSolution.description.paragrafs.paragraf2",
        },
      ],
    },
    businessChallenges: t(
      "caseStudies.biHealthcareSolution.businessChallenges",
      {
        returnObjects: true,
      }
    ),
    ourSolutions: t("caseStudies.biHealthcareSolution.ourSolutions", {
      returnObjects: true,
    }),
    theResults: {
      header: "caseStudies.biHealthcareSolution.theResults.header",
      content: [
        {
          header: t(
            "caseStudies.biHealthcareSolution.theResults.results.result1.text"
          ),
          image: imgResult1,
          bgColor: "white",
        },
        {
          header: t(
            "caseStudies.biHealthcareSolution.theResults.results.result2.text"
          ),
          image: imgResult2,
          bgColor: "softBlue",
        },
        {
          header: t(
            "caseStudies.biHealthcareSolution.theResults.results.result3.text"
          ),
          image: imgResult3,
          bgColor: "thertiary",
        },
        {
          header: t(
            "caseStudies.biHealthcareSolution.theResults.results.result4.text"
          ),
          bgColor: "thertiary",
          image: imgResult4,
        },
      ],
    },
    moreStories: {
      title: t("caseStudies.biHealthcareSolution.moreStories.header"),
      stories: t("caseStudies.biHealthcareSolution.moreStories.stories", {
        returnObjects: true,
      }),
    },
  };
  return <CaseStudyTemplatePage data={data} />;
};

export default CaseStudyBIHealthcareSolutionPage;
